import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "max-height overflow-auto center" }
const _hoisted_2 = ["src"]

import { IonGrid, IonRow, IonCol, IonIcon } from "@ionic/vue";

import ButtonFix from "@/components/button/ButtonFix.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { CartData } from "@/types/supplier";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderSuccess',
  props: {
    cartData: {}
  },
  emits: ["next"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonGrid), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "center flex-d-c px-4" }, {
              default: _withCtx(() => [
                (__props.cartData?.supplier?.imageLink)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "card-border",
                      style: {"max-height":"300px"},
                      alt: "",
                      src: (__props.cartData?.supplier?.imageLink.startsWith('/')) ? `https://app.octopusorder.com${__props.cartData?.supplier?.imageLink}` : __props.cartData?.supplier?.imageLink
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createBlock(_unref(IonIcon), {
                      key: 1,
                      icon: "assets/icon/logo.svg",
                      class: "octo-logo coral-coral-color fs-28"
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), { class: "pb-3 pt-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-22 fw-600 ion-text-center octo-gradient-purple-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.order.sent', { target: __props.cartData.supplier.name ?? 'ihren Lieferanten' })), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), { class: "pb-3" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "center" }, {
              default: _withCtx(() => [
                _createVNode(ButtonFix, {
                  color: _unref(ION_VARIANT).CORAL,
                  class: "light-light-color light-medium-shadow",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('next')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.ok')), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})